import { __ } from '@wordpress/i18n';
import AreaRenderer from '../areas/AreaRenderer';

const AREA_LABELS = {
  'price-details': __('Price Details', 'havenlytics'),
  'schedule-tour': __('Schedule Tour', 'havenlytics'),
  'features': __('Features', 'havenlytics'),
  'excerpt': __('Excerpt', 'havenlytics'),
  'location': __('Location', 'havenlytics')
};

const BasicPreviewCard = ({ sections, onOpenModal, onEditField, onDeleteField }) => (
  <div className="hvnly--builder---api_property__builder___single_page_card">
    <div className="hvnly--builder---api_property__builder___single_page_card_header">
      {/* Thumbnail Area */}
      <AreaRenderer 
        area="thumbnail"
        sections={sections}
        onOpenModal={onOpenModal}
        onEditField={onEditField}
        onDeleteField={onDeleteField}
        mode="preview"
      />
      
      {/* Corner Areas */}
      <div className="hvnly--builder---api_property__builder___single_page_card_corner hvnly--builder---api_property__builder___single_page_card_top_left">
        <AreaRenderer 
          area="top-left"
          sections={sections}
          onOpenModal={onOpenModal}
          onEditField={onEditField}
          onDeleteField={onDeleteField}
          mode="preview"
        />
      </div>
      
      <div className="hvnly--builder---api_property__builder___single_page_card_corner hvnly--builder---api_property__builder___single_page_card_top_right">
        <AreaRenderer 
          area="top-right"
          sections={sections}
          onOpenModal={onOpenModal}
          onEditField={onEditField}
          onDeleteField={onDeleteField}
          mode="preview"
        />
      </div>
      
      <div className="hvnly--builder---api_property__builder___single_page_card_corner hvnly--builder---api_property__builder___single_page_card_bottom_left">
        <AreaRenderer 
          area="bottom-left"
          sections={sections}
          onOpenModal={onOpenModal}
          onEditField={onEditField}
          onDeleteField={onDeleteField}
          mode="preview"
        />
      </div>
      
      <div className="hvnly--builder---api_property__builder___single_page_card_corner hvnly--builder---api_property__builder___single_page_card_bottom_right">
        <AreaRenderer 
          area="bottom-right"
          sections={sections}
          onOpenModal={onOpenModal}
          onEditField={onEditField}
          onDeleteField={onDeleteField}
          mode="preview"
        />
      </div>
    </div>
    
    <div className="hvnly--builder---api_property__builder___single_page_card_body">

      {/* Avatar Area */}
      <AreaRenderer 
        area="avatar"
        sections={sections}
        onOpenModal={onOpenModal}
        onEditField={onEditField}
        onDeleteField={onDeleteField}
        mode="preview"
      />
      
      {/* Content Areas */}
      <div className="hvnly--builder---api_property__builder___editable_area">
        <span className="hvnly--builder---api_property__builder___area_label">{__('Title Area', 'havenlytics')}</span>
        <div className="hvnly--builder---api_property__builder___single_page_card_title_area">
          <AreaRenderer 
            area="title"
            sections={sections}
            mode="preview"
          />
        </div>
      </div>
      
      <div className="hvnly--builder---api_property__builder___editable_area">
        <span className="hvnly--builder---api_property__builder___area_label">{__('Content Area', 'havenlytics')}</span>
        <div className="hvnly--builder---api_property__builder___single_page_card_content_area">
          <AreaRenderer 
            area="content"
            sections={sections}
            mode="preview"
          />
        </div>
      </div>
      
      {/* Additional Areas */}
      {/* Add this part to include more areas like price-details, schedule-tour, features, excerpt, location */}
      {['price-details', 'schedule-tour', 'features', 'excerpt', 'location'].map(area => (
        <div key={area} className="hvnly--builder---api_property__builder___editable_area">
          <span className="hvnly--builder---api_property__builder___area_label">{AREA_LABELS[area]}</span>
          <div className={`hvnly--builder---api_property__builder___single_page_card_${area.replace('-', '_')}_area`}>
            <AreaRenderer 
              area={area}
              sections={sections}
              mode="preview"
            />
          </div>
        </div>
      ))}
    </div>
    
    {/* Footer Area */}
    <div className="hvnly--builder---api_property__builder___single_page_card_footer">
      <div className="hvnly--builder---api_property__builder___single_page_card_footer_left">
        <AreaRenderer 
          area="footer-left"
          sections={sections}
          mode="preview"
        />
      </div>
      <div className="hvnly--builder---api_property__builder___single_page_card_footer_right">
        <AreaRenderer 
          area="footer-right"
          sections={sections}
          mode="preview"
        />
      </div>
    </div>
  </div>
);

export default BasicPreviewCard;